module.exports = __webpack_public_path__ + "img/ep-coeur2.4b975327.jpg";